module.exports = __webpack_public_path__ + "static/voorlater-2-504900839f82da57a3e577c2d355d32f.png";